import { consumerOnboardingLabels } from './consumer-onboarding-labels';
import { salesOnboardingLabels } from './sales-onboarding-labels';

export const onboardingLabels = {
  consumer: consumerOnboardingLabels,
  sales: salesOnboardingLabels,
};
